import { UseMutationOptions, useMutation } from 'react-query';
import { mutateRaceStatus } from './raceStatus';
import { TRaceStatus } from './raceStatus.types';

export const useMutationRaceStatus = (
  options?: UseMutationOptions<unknown, unknown, TRaceStatus>
) => useMutation((data) => mutateRaceStatus(data), options);
